export default function TouchBackgroundImageForButton(props) {
  const { product } = props;

  return product.image ? (
    <div
      style={{
        position: 'absolute',
        width: '40px',
        height: '40px',
        top: '-10px',
        left: '-10px',
        backgroundImage: `url('${product.image}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '40px 40px',
        border: '1px solid #0d6efd',
        borderRadius: '30px',
      }}
    ></div>
  ) : (
    <></>
  );
}
